import { defineComponent as _defineComponent } from 'vue';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'Components/primitives/tooltip';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnTooltip',
    props: {
        text: { type: String, required: false, default: undefined },
        position: { type: null, required: false, default: 'top' },
        staticId: { type: [String, Number, null], required: false, default: null },
        disabled: { type: Boolean, required: false, default: false },
        contentClass: { type: String, required: false, default: undefined },
        open: { type: Boolean, required: false, default: undefined }
    },
    emits: ["update:open"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const __returned__ = { emit, get Tooltip() { return Tooltip; }, get TooltipContent() { return TooltipContent; }, get TooltipProvider() { return TooltipProvider; }, get TooltipTrigger() { return TooltipTrigger; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
